import Chart from "react-apexcharts";

export default function GraficoDonut({ title, labels, values, position }) {
    const newPosition = position ? position : 'right';

    const options = {
        chart: {
            type: "donut"
        },
        labels: labels, // categorias
        legend: {
            position: newPosition,
            fontSize: "12px",
            labels: { colors: "#333" },
        },
        tooltip: {
            y: {
                formatter: (value) =>
                    Number(value).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    }),
            }
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "50%", // define o tamanho do “buraco”
                },
            },
        },
        responsive: [
            {
                breakpoint: 768,
                options: {
                    legend: { position: "bottom" },
                },
            },
        ],
    };

    const series = values;

    return (
        <div className="bg-white p-4 rounded-2xl shadow-md fade-in">
            <h2 className="text-xl font-bold mb-2">{title}</h2>
            {values.length > 0 ?
                <Chart options={options} series={series} type="donut" height={350} />
                :
                "Não existem dados disponíveis para o intervalo selecionado."
            }
        </div>
    );
}
